// @flow

import * as React from 'react';
import { NavLink } from 'react-router-dom';
import { InfoCircleOutlined } from '@ant-design/icons';
import { Icon as LegacyIcon } from '@ant-design/compatible';
import { Table, Popover } from 'antd';
import moment from 'moment';
import numeral from 'numeral';
import { sortBy, reverse } from 'lodash';
import { getTeamUrl } from 'Common';

type Props = {
  project: Object,
  fetching: Boolean,
}

export default class extends React.PureComponent<Props> {

  render() {
    const {
      project,
      fetching,
    } = this.props;

    const columns = [
      {
        title: 'Reference',
        dataIndex: '',
        width: 155,
        render: (text, record) => (
          <NavLink to={getTeamUrl(`orders/${record.id}/view`)}>
            {record.reference}
          </NavLink>
        )
      },

      {
        title: 'Client / Site',
        dataIndex: '',
        width: 252,
        render: () => (

          <div>

            <div className="ellipsis">
              <strong>
                {project.client_site.client.name}
              </strong>
            </div>

            <div className="ellipsis">
              {project.client_site.name}
            </div>

          </div>

        )
      },

      {
        title: ' ',
        dataIndex: '',
        key: 'notes',
        width: 25,
        sorter: false,
        render: (text, record) => record.notes && (
          <Popover
            title="Notes"
            trigger="hover"
            content={(
              <div style={{ maxWidth: 300 }}>
                {record.notes}
              </div>
            )}
            style={{ maxWidth: 300 }}
          >
            <InfoCircleOutlined style={{ color: '#1890FF', fontSize: 18 }} />
          </Popover>
        ),
        onCell: () => ({ style: { padding: 0 } })
      },

      {
        title: 'Project No.',
        dataIndex: 'client_project_number',
        width: 200,
      },

      {
        title: 'Date',
        dataIndex: '',
        width: 120,
        render: (text, record) => (
          <div>
            {record.date ? moment(record.date).format('DD MMM YYYY') : '--'}
          </div>
        )
      },

      {
        title: 'Procurement Value',
        dataIndex: '',
        width: 160,
        render: (text, record) => (
          <span>
            {`£ ${numeral(record.procurement_items_sum_total_cost || 0).format('0,0.00')}`}
          </span>
        )
      },

      {
        title: 'New / Extra / Procurement',
        key: 'extra_works',
        width: 180,
        render: (text, record) => {
          if (record.extra_works === 2) {
            return <div><LegacyIcon type='shopping-cart' style={{ color: '#722ed1' }} />{' Procurement'}</div>
          }
          return (
            <div>
              <LegacyIcon type={record.extra_works ? 'plus' : 'star'} style={{ color: record.extra_works ? 'limegreen' : '#1990FF' }} />
              {record.extra_works ? ' Extra Works' : ' New Works'}
            </div>
          )
        },
      },

    ];

    const scroll = { x: columns.reduce((total, column) => total + column.width, 150) };

    const orders = reverse(sortBy(
      (project.orders || []).filter(o => o.procurement_items_sum_total_cost > 0),
      ['date']
    ))

    return (
      <Table
        dataSource={orders}
        columns={columns}
        loading={fetching}
        rowKey='id'
        scroll={scroll}
      />
    )
  }
}
